import type { App, Plugin } from "vue";
import VueApexCharts from "vue3-apexcharts";

export function initApexCharts(app: App) {
  app.use(VueApexCharts as unknown as Plugin);
}
